module.exports = __webpack_public_path__ + "img/XIaoToR.d3a6661d.svg";